import { render, staticRenderFns } from "./_TopHeader.vue?vue&type=template&id=452f7ba3&"
import script from "./_TopHeader.vue?vue&type=script&lang=js&"
export * from "./_TopHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports